import React from 'react'
import { scrollToTop } from 'chemistry'
import { focusableSelector } from 'client/common/accessability'

export const PageButton = ({ number, link = '#', isCurrent, onClick }) => {
  if (isCurrent) return <strong rel='current'>{number}</strong>

  return (
    <a href={link} className='link-radius' onClick={e => onClickHandler(e, () => onClick(number))}>
      {number}
    </a>
  )
}

export const onClickHandler = (event, callback) => {
  event.preventDefault()
  scrollToTop(200)
  callback?.(event)?.then(focusFirstProduct)
}

export const focusFirstProduct = () => {
  document.querySelector(`.mxd-product-area-new-lister-view ${focusableSelector}`).focus()
}
